import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import $ from "jquery";
import logo from "../images/logo.png";

export default function NavBar() {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  const onNavClick = () => {
    setNavOpen(!navOpen);
    if (navOpen) {
      $("#overlay").hide();
      $(".lines-button").removeClass("close");
    } else {
      $("#overlay").show();
      $(".lines-button").addClass("close");
    }
  };

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 1200);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  return isMobile ? (
    <NavBarMobile>
      <div
        style={{
          padding: 5,
          width: "60px",
          height: "60px",
          backgroundColor: "#FCFAF2",
          borderRadius: "50%",
          border: "1px solid #333",
          position: "absolute",
          top: "0%",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
        }}
      >
        <img
          alt="logo"
          src={logo}
          style={{
            borderRadius: "50%",
            width: "60px",
            border: "1px solid black",
            marginLeft: -0.5,
            marginTop: -0.5,
          }}
        />
      </div>
      <button className="lines-button lines" onClick={() => onNavClick()}>
        <span></span>
      </button>
      {navOpen ? (
        <Container>
          <Column>
            <div
              style={{
                display: "flex",
                backgroundColor: "#FCFAF2",
                width: "99.1vw",
                justifyContent: "right",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              {/* <p className='font-main' style={{color: 'white', fontSize: 15,  margin: '15px auto auto 20px' }}>Lexi Lakota Photography</p> */}
              {/* <img    src={logo} alt='logo' style={{borderRadius: 300, margin: '40px auto 40px auto', width: '60vw', boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.5)'}} onClick={() => navigate('/')}/> */}
              <NavText
                onClick={() => {
                  navigate("/");
                  onNavClick();
                }}
              >
                HOME
              </NavText>
              <NavText
                onClick={() => {
                  navigate("/about");
                  onNavClick();
                }}
              >
                ABOUT
              </NavText>
              <NavText
                onClick={() => {
                  navigate("/testimonials");
                  onNavClick();
                }}
              >
                TESTIMONIALS
              </NavText>
              <NavText
                onClick={() => {
                  navigate("/portfolio");
                  onNavClick();
                }}
              >
                PORTFOLIO
              </NavText>
              <NavText
                onClick={() => {
                  navigate("/pricing");
                  onNavClick();
                }}
              >
                PRICING
              </NavText>
              <NavText
                onClick={() => {
                  navigate("/inquire");
                  onNavClick();
                }}
              >
                INQUIRE
              </NavText>
              <p style={{ marginTop: "100px" }}>@RAINBOWTROUTREVERIE</p>
            </div>
          </Column>
        </Container>
      ) : (
        <></>
      )}
    </NavBarMobile>
  ) : (
    <NavBar1>
      <NavInner>
        <NavCluster>
          <NavItem onClick={() => navigate("/")}>HOME</NavItem>
          <NavItem onClick={() => navigate("/about")}>ABOUT</NavItem>
          <NavItem onClick={() => navigate("/testimonials")}>
            TESTIMONIALS
          </NavItem>
        </NavCluster>

        <Title onClick={() => navigate("/")}>RAINBOW TROUT REVERIE</Title>

        <NavCluster>
          <NavItem onClick={() => navigate("/portfolio")}>PORTFOLIO</NavItem>
          <NavItem onClick={() => navigate("/pricing")}>PRICING</NavItem>
          <NavItem onClick={() => navigate("/inquire")}>INQUIRE</NavItem>
        </NavCluster>
      </NavInner>
    </NavBar1>
  );
}

const NavItem = styled.p`
  font-size: 0.95em;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  background: transparent;
  letter-spacing: 0.08em;
  font-weight: 100;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const NavBar1 = styled.header`
  position: absolute; /* sits on top */
  top: 0;
  left: 0;
  width: 100%;
  height: 68px; /* actual height */
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* stays above other elements */

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

const NavInner = styled.div`
  width: min(1200px, 92vw);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 10px 18px;
`;

const NavCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
`;

const NavBarMobile = styled.header`
  position: fixed; /* sits on top */
  top: 0;
  left: 0;
  width: 100%;
  height: 40px; /* actual height */
  background-color: #fcfaf2;
  display: flex;
  align-items: center;
  z-index: 9999; /* stays above other elements */
  border-bottom: 1px solid black;
`;

const Title = styled.h1`
  font-size: 2em;
  font-weight: 300;
  color: #ffffff;
  cursor: pointer;
`;

const Container = styled.div`
  position: absolute;
  left: 60%;
  top: 41px;
  z-index: 5;
  background-color: #fcfaf2;
  width: 40vw;
  height: 50vh;
  left: 0px;
  width: 100vw;
  text-align: left;
  padding-top: 30px;
`;

const NavText = styled.p`
  margin: 20px auto auto 20px;
  font-size: 20px;
  cursor: pointer;
  color: #333;
  verticalalign: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
